import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import { LoadingButton } from '@mui/lab';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import Typography from '@material-ui/core/Typography';

import { AuthContext } from '../../../@jumbo/components/context/AuthContext';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import AddIcon from '@material-ui/icons/Add';
import { useSnackbar } from 'notistack';
import { TableFooter, TextField } from '@material-ui/core';
import { Box, TablePagination } from '@mui/material';
import AgentReqEdit from '../agent/AgentReqEdit';
// import AgentReqEdit from './AgentReqEdit';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import CurrencyRateCreate from './CurrencyRateCreate';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },

  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  container: {
    maxHeight: 'calc(100vh - 230px)',
    overflow: 'auto',
  },

  cellWidth: {
    width: '230px',
  },

  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },

  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },
  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '600px',
  },
  alignCenter: {
    textAlign: 'center',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
}));

const AllBaseCurrency = () => {
  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const { enqueueSnackbar } = useSnackbar();
  const [list, setList] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [addDialog, setAddDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [count, setCount] = useState(0);

  const [company, setCompany] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [businessPhone, setBusinessPhone] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setAddDialog(false);
  };

  const openUpdateDialog = () => {
    setUpdateDialog(true);
  };
  const closeUpdateDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    setUpdateDialog(false);
  };
  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [itemId, setItemId] = useState('');
  const [usdToSourceRate, setUsdToSourceRate] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = () => {
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const handleSearch = () => {
    getList();
  };
  const handleClear = () => {
    setFirstName('');
    setLastName('');
    setCompany('');
    setBusinessPhone('');
    setBusinessEmail('');
  };

  const getList = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let uri = `${process.env.REACT_APP_BASE_URL}/api/v1/private/all-base-currency?page=${page}&size=${perPage}`;
    let url = new URL(uri);

    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        console.log('response', response);
        setList(response.data.data);
        // setCount(response.data.data.totalElements);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const handleDelete = async () => {
    // return console.log('handleDeleteID', deleteId);
    setLoadingDelete(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/agent/request/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('res.id', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
        handleSnakbarOpen(response.data.message, 'success');
      })
      .catch(function(error) {
        // handle error
        setDeleteDialog(false);
        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      });
    setLoadingDelete(false);
  };

  const handleApprove = async id => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    try {
      let response = await axios({
        url: `/api/v1/private/approve/agent/request/${id}`,
        method: 'post',
        data: '',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      handleSnakbarOpen(response.data.message, 'success');
      getList();
      setOpenDetailView(false);
      return;
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setOpenDetailView(false);
    }
    setLoading(false);
  };

  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);
    let data = new FormData();
    data.append('usdToSourceRate', usdToSourceRate);
    try {
      let response = await axios({
        url: `/api/v1/private/currency-conversion-rate/${itemId}`,
        method: 'PUT',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      closeUpdateDialog();
      handleSnakbarOpen(response.data.message, 'success');
      getList();
    } catch (error) {
      console.log('error', error);
      console.log('errorresponse', error.response);

      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 20; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };
  useEffect(() => {
    getCountry();
  }, []);
  useEffect(() => {
    getList();
  }, [page]);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">Currency Conversion Rate</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer component={Paper} className={classes.container}>
              <Table stickyHeader aria-label="simple table">
                <TableHead className={classes.tableHeadStyle}>
                  <TableRow>
                    <TableCell align="left">Source Currency</TableCell>
                    <TableCell align="left">USD To Source Rate</TableCell>
                    <TableCell align="left">Created At</TableCell>
                    <TableCell align="left">Updated At</TableCell>
                    <TableCell align="center" className={classes.cellWidth}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={classes.tableBodyStyle}>
                  {list.length > 0 && !loading
                    ? list.map((row, i) => (
                        <TableRow hover key={i}>
                          <TableCell align="left" scope="row">
                            {row.sourceCurrency}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {row.usdToSourceRate}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {moment(row.createdAt).format('D MMM YYYY, h:mm:ss a')}
                          </TableCell>
                          <TableCell align="left" scope="row">
                            {moment(row.updatedAt).format('D MMM YYYY, h:mm:ss a')}
                          </TableCell>

                          <TableCell align="center">
                            {/* <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                              <VisibilityIcon />
                            </IconButton> */}
                            <IconButton
                              className={classes.editButton}
                              onClick={() => {
                                openUpdateDialog();
                                setItemId(row.id);
                                setUsdToSourceRate(row.usdToSourceRate);
                              }}>
                              <EditIcon />
                            </IconButton>
                            {/* <IconButton
                              color="secondary"
                              onClick={() => {
                                handleDeleteDialogClickOpen();
                                setDeleteId(row.id);
                              }}>
                              <DeleteIcon />
                            </IconButton> */}
                          </TableCell>
                        </TableRow>
                      ))
                    : null}
                  {!loading && list.length === 0 && (
                    <TableRow>
                      <TableCell colSpan="10" style={{ textAlign: 'center' }}>
                        {message}
                      </TableCell>
                    </TableRow>
                  )}
                  {loading && pageLoading()}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
              component="div"
              rowsPerPageOptions={[]}
              count={count}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={perPage}
            /> */}
          </Paper>
        </Grid>
      </Grid>

      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <CurrencyRateCreate
              list={list}
              allCountry={allCountry}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================update Dialog start============================== */}

      <div>
        <Dialog
          open={updateDialog}
          onClose={closeUpdateDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
              <Typography variant="h3">Update the currency conversion rate</Typography>
              <TextField
                id="name"
                label="Name"
                variant="outlined"
                fullWidth
                size="small"
                type="number"
                className={`${classes.marginStyle} ${classes.inputStyle}`}
                value={usdToSourceRate}
                onChange={e => setUsdToSourceRate(e.target.value)}
              />
              <Box>
                <Button
                  variant="contained"
                  className={classes.buttonStyle}
                  color="primary"
                  disabled={loading}
                  style={{ marginBottom: '30px' }}
                  onClick={onSubmit}>
                  {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
                  Submit
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================update Dialog End============================== */}
      {/* ==================Delete Dialogue start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogTitle>
              <Typography variant="h3">Are you sure to delete ?</Typography>
            </DialogTitle>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <LoadingButton loading={loadingDelete} color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default AllBaseCurrency;
